import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import AdminAddMemberView from '../../../containers/Zones/Admin/AdminAddMember'

const AdminAddMember = () => {
  const {communityInfo} = useSelector(state=>state.userInfo)
  const [usersToInvite, setUsersToInvite] = useState([]);
  return (
    <AdminAddMemberView zone={communityInfo} usersToInvite={usersToInvite} setUsersToInvite={setUsersToInvite}/>
  )
}

export default AdminAddMember